<template>
  <h1> A note keeping website built using VueJs, Firebase and Vue-Material.</h1>
</template>

<script>
export default {
  
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Default.vue